import React from "react";
import { MOB_ICONS } from ".";
import { Empty, Typography } from "antd";

const NoData = (props) => {
  return (
    <div className="d-flex justify-content-center align-content-center">
      <div className={props.className || "py-3"}>
        <img
          src={MOB_ICONS.NO_DATA.default}
          style={{ width: props.imgWidth || "200px" }}
        />
        <div
          className="pt-2 text-muted fs-5  text-center"
          style={{ fontSize: "13px" }}
        >
          <Typography.Text>{props.title || "No Data"}</Typography.Text>
          {/*<Empty
          image={MOB_ICONS.NO_DATA.default}
          imageStyle={{
            height: 60,
          }}
          description={
            <Typography.Text>{props.title || "No Data"}</Typography.Text>
          }
        ></Empty>*/}
        </div>
      </div>
    </div>
  );
};

export default NoData;
